import { Col } from "react-bootstrap";

export const GameCard = ({ title, description, imgUrl, onClick, dbName }) => {
  return (
    <Col size={12} sm={6} md={4} onClick={() => onClick(title,dbName)} style={{ cursor: "pointer" }}>
      <div className="proj-imgbx" style={{ 
        width: "100%", 
        height: "250px",
        overflow: "hidden",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#111",
      }}>
        <img src={imgUrl} alt={title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain"
          }}/>
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  )
}